// shared types and constants for create/edit agent forms

import { AgentFaq, AgentOwnerInfo, AgentRelatedLink } from '../../../../domain/agents/models/Agent';
import { ConversationStarterItem } from '../../../../domain/chat/models/ConversationStarterLibrary';
import { FunctionToolFormDefinition } from './FunctionToolForm';

export interface CreateAgentFormValues {
    name: string;
    description: string;
    model: string;
    instructions: string;
    tools: string[];
    functionTools: FunctionToolFormDefinition[];
    agentIconUrl: string;
    cardShortDescription: string;
    disclaimer: string;
    knowledgeBaseContent: string;
    promptLibrary: ConversationStarterItem[];
    faqs: AgentFaq[];
    ownerInfo: AgentOwnerInfo[];
    supportAddress: string;
    capabilities: { value: string }[];
    relatedLinks: AgentRelatedLink[];
    allowFileSearchAtConversationLevel: boolean;
    allowCodeInterpreterAtConversationLevel: boolean;
    selectedMcpServerIds: string[];
}

export interface EditAgentFormValues {
    description: string;
    model: string;
    instructions: string;
    tools: string[];
    functionTools: FunctionToolFormDefinition[];
    agentIconUrl: string;
    cardShortDescription: string;
    disclaimer: string;
    knowledgeBaseContent: string;
    promptLibrary: ConversationStarterItem[];
    faqs: AgentFaq[];
    ownerInfo: AgentOwnerInfo[];
    supportAddress: { email: string }[];
    capabilities: { value: string }[];
    relatedLinks: AgentRelatedLink[];
    allowFileSearchAtConversationLevel: boolean;
    allowCodeInterpreterAtConversationLevel: boolean;
    selectedMcpServerIds: string[];
}

export const toolOptions = [
    { value: 'fileSearch', label: 'File Search' },
    { value: 'codeInterpreter', label: 'Code Interpreter' },
    { value: 'functionCalling', label: 'Function Calling' },
    { value: 'mcpServer', label: 'MCP Server' },
] as const;

export const DESCRIPTION_MAX_LENGTH = 512;
export const INSTRUCTIONS_MAX_LENGTH = 256000;
export const CARD_SHORT_DESCRIPTION_MAX_LENGTH = 275;
export const DISCLAIMER_MAX_LENGTH = 275;
export const RELATED_LINK_MAX_ITEMS = 5;
export const CAPABILITIES_MAX_ITEMS = 10;
export const FAQ_MAX_ITEMS = 10;
export const PROMPT_MAX_ITEMS = 10;
export const SHORT_ENTRY_MAX_LENGTH = 275;
export const PROMPT_DESCRIPTION_MAX_LENGTH = 500;
export const CAPABILITY_MAX_LENGTH = 500;
export const KNOWLEDGE_BASE_MAX_LENGTH = 700;

export const AGENT_UPLOAD_MAX_FILE_COUNT = Number(process.env.REACT_APP_MAX_FILE_COUNT_UPLOAD_AGENT_LEVEL ?? '100');
export const AGENT_UPLOAD_MAX_FILE_SIZE_MB = Number(process.env.REACT_APP_MAX_FILE_SIZE_UPLOAD_AGENT_LEVEL ?? '30');

export const companyEmailPattern = /^[a-zA-Z0-9._%+-]+@(roberthalf|protiviti)\.com$/;
